import { t as e } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { BUTTON_ICON_SIZES as t } from "../button/button-constants.js";
import n from "../button/button.js";
import { createBlock as r, createSlots as i, normalizeClass as a, openBlock as o, renderSlot as s, resolveComponent as c, resolveDirective as l, withCtx as u, withDirectives as d } from "vue";
//#region components/split_button/split_button-start.vue
var f = {
	compatConfig: { MODE: 3 },
	name: "SplitButtonStart",
	components: { DtButton: n },
	props: {
		active: {
			type: Boolean,
			default: !1
		},
		ariaLabel: {
			type: String,
			default: null
		},
		iconPosition: {
			type: String,
			default: "left"
		},
		labelClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		leadingClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		trailingClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		loading: {
			type: Boolean,
			default: !1
		},
		tooltipText: {
			type: String,
			default: ""
		},
		assertiveOnFocus: {
			type: Boolean,
			default: !1
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		importance: {
			type: String,
			default: "primary"
		},
		kind: {
			type: String,
			default: "default"
		},
		size: {
			type: [String, Number],
			default: 300
		},
		to: {
			type: [String, Object],
			default: null
		},
		replace: {
			type: Boolean,
			default: !1
		},
		href: {
			type: String,
			default: null
		},
		target: {
			type: String,
			default: null
		},
		rel: {
			type: String,
			default: null
		}
	},
	data() {
		return { BUTTON_ICON_SIZES: t };
	},
	computed: { tooltipConfig() {
		return {
			message: this.tooltipText,
			inverted: this.kind === "inverted"
		};
	} }
};
function p(e, t, n, f, p, m) {
	let h = c("dt-button"), g = l("dt-tooltip");
	return d((o(), r(h, {
		"data-qa": "dt-split-button-start",
		active: n.active,
		"aria-label": n.ariaLabel,
		"assertive-on-focus": n.assertiveOnFocus,
		class: a(`d-split-btn__start d-split-btn__start--${n.size}`),
		disabled: n.disabled,
		"icon-position": n.iconPosition,
		importance: n.importance,
		kind: n.kind,
		"label-class": n.labelClass,
		"leading-class": n.leadingClass,
		"trailing-class": n.trailingClass,
		loading: n.loading,
		size: n.size,
		to: n.to,
		replace: n.replace,
		href: n.href,
		target: n.target,
		rel: n.rel
	}, i({
		default: u(() => [s(e.$slots, "default")]),
		_: 2
	}, [
		e.$slots.startIcon ? {
			name: "startIcon",
			fn: u(() => [s(e.$slots, "startIcon", { size: p.BUTTON_ICON_SIZES[n.size] })]),
			key: "0"
		} : void 0,
		e.$slots.endIcon ? {
			name: "endIcon",
			fn: u(() => [s(e.$slots, "endIcon", { size: p.BUTTON_ICON_SIZES[n.size] })]),
			key: "1"
		} : void 0,
		e.$slots.icon && !e.$slots.startIcon && !e.$slots.endIcon ? {
			name: "icon",
			fn: u(() => [s(e.$slots, "icon", { size: p.BUTTON_ICON_SIZES[n.size] })]),
			key: "2"
		} : void 0,
		e.$slots.leading ? {
			name: "leading",
			fn: u(() => [s(e.$slots, "leading")]),
			key: "3"
		} : void 0,
		e.$slots.trailing ? {
			name: "trailing",
			fn: u(() => [s(e.$slots, "trailing")]),
			key: "4"
		} : void 0
	]), 1032, [
		"active",
		"aria-label",
		"assertive-on-focus",
		"class",
		"disabled",
		"icon-position",
		"importance",
		"kind",
		"label-class",
		"leading-class",
		"trailing-class",
		"loading",
		"size",
		"to",
		"replace",
		"href",
		"target",
		"rel"
	])), [[g, m.tooltipConfig]]);
}
var m = /* @__PURE__ */ e(f, [["render", p]]);
//#endregion
export { m as default };

//# sourceMappingURL=split-button-start.js.map